export default {"src":"/_next/static/media/check.4a3b97de.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};